<body>
  <app-header></app-header>
  <!-- Header Section -->
  <div class="relative w-full h-[400px] flex justify-center items-center">
    <img
      src="assets/TrailFusion/banner-explore.jpg"
      alt="banner"
      class="absolute inset-0 w-full h-full object-cover brightness-75"
    />
    <div class="relative text-white text-center px-4 animate-fade-in">
      <h1 class="text-4xl font-extrabold">
        Welcome to <a href="" class="text-teal-600">TrailFusion</a>
      </h1>
      <h2 class="text-lg mt-2 font-semibold">
        We’re proud to support organizations that create opportunities,<br />
        build confidence, and strengthen communities.
      </h2>
      <!-- <h3 class="text-2xl mt-4 font-bold">
        Empowering Nonprofits & Educators – Simplify, Streamline, Succeed.
      </h3> -->
    </div>
  </div>

  <!-- Clients Section -->
  <section class="bg-gray-50 py-16">
    <div class="max-w-6xl mx-auto px-6 text-center">
      <h2 class="text-3xl md:text-4xl font-extrabold mb-12">
        Our Clients, <span class="text-teal-600">Our Partners in Impact</span>
      </h2>

      <!-- Cards Grid -->
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
        <div
          *ngFor="let org of organizations"
          class="border border-gray-250 rounded-lg py-4 flex flex-col items-center hover:shadow-lg transition"
        >
          <img
            [src]="
              org.orgImage || 'assets/TrailFusion/Miscellaneous/about2.png'
            "
            [alt]="org.orgName"
            class="w-56 h-56 object-contain"
          />
          <div class="mt-2">
            <a
              [routerLink]="['/know-your-client']"
              [queryParams]="{ orgId: org.id }"
              class="px-5 py-2 text-teal-600 underline hover:text-teal-700 transition underline-offset-4"
            >
              Know More
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <app-footer></app-footer>
</body>
